<template>
  <div>
    <portal-target name="diagPortal"></portal-target>
    <b-table
      id="dTable"
      striped
      bordered
      small
      head-variant="dark"
      :items="diagList"
      :fields="fields">
    </b-table>
    <portal to="diagPortal">
      <button id="close"
              @click="diagClose"><div id="bInner">X</div></button>
    </portal>
  </div>
</template>

<script>
export default {
  name: 'diag-list',
  data() {
    return {
      fields: [
        { key: 'time', label: 'Time' },
        { key: 'info', label: 'Diagnostic Info' },
      ],
    };
  },
  methods: {
    diagClose() {
      this.$emit('exit');
    },
  },
  computed: {
    diagList() {
      return this.$store.getters.getDiagList;
    },
  },
};
</script>

<style scoped>
  #dTable {
    position: relative;
    margin: 0;
    font-size: 10px;
    horiz-align: left;
    text-align: left;
  }
  #close {
    position: absolute;
    width: 20px;
    height: 20px;
    background: red;
    top: 0px;
    right: 0px;
    cursor: pointer;
    z-index: 100;
  }
  #bInner {
    position: absolute;
    display: block;
    font-size: 18px;
    font-weight: bold;
    color: black;
    top: -4px;
    left: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/diagList.vue